// 碳积分提现分红
export default {
  routes: [
    {
      path: '/withdraw',
      name: 'withdraw',
      meta: {
        title: '分红收益'
      },
      component: () => import(/* webpackChunkName: "withdraw" */ '../views/withdraw/index.vue')
    },
    {
      path: '/withdraw-detail',
      name: 'withdraw-detail',
      meta: {
        title: '明细记录'
      },
      component: () =>
        import(/* webpackChunkName: "withdraw-detail" */ '../views/withdraw/detail.vue')
    }
  ]
}
